import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import {videoModal} from './modals';

const VideoPlayer = () => {

    let videos = document.querySelectorAll('.video-player');
    Vue.use(VModal);

    let VideoConstructor = (id) => {
        Vue.component('video-player-template', {
            data: function() {
                return {
                    videoUrl: '',
                    videoName: null
                }
            },
            methods: {
                launchVideo() {
                    this.$modal.show(
                        videoModal.template(this.videoUrl, this.videoName),
                        videoModal.name,
                        videoModal.options
                    )
                }
            },
            mounted() {
                this.videoUrl = this.$refs.overlay.dataset.videoId;
                this.videoName = this.$refs.name ? this.$refs.name.innerHTML : null;
            }
        });
    
        new Vue({
            el: `.video-player-${id}`,
        }).$mount(`.video-player-${id}`, true);
    }

    if (videos.length > 0) {
        videos.forEach((item, index) => {
            item.classList.add(`video-player-${index}`);
            VideoConstructor(index);
        })
    }
}

export default VideoPlayer;